import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ResetParcelModal = ({ show, resettingParcel, onClose, onResetParcel }) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('Reiniciar envío')} show={show} size="l" onClose={onClose}>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Esta acción devolverá el envío a su estado inicial, cancelando la etiqueta de envío generada y eliminando el estado de empaquetado de los productos.'
          )}
        </Text>

        <Alert type="info">
          {t('El estado de preparación de los productos en la plataforma de comercio electrónico no cambiará.')}
        </Alert>

        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardar')}
            disabled={resettingParcel}
            loading={resettingParcel}
            onClick={onResetParcel}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default ResetParcelModal
